function toScenarioOutput(scenarioLike) {
  if (!scenarioLike) return {};
  return scenarioLike.scenarioOutput || scenarioLike;
}

function normalizeWhitespace(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function parseAgeValue(ageRaw) {
  const text = normalizeWhitespace(ageRaw);
  const numericMatch = text.match(/(\d+(\.\d+)?)/);
  return {
    text,
    numeric: numericMatch ? parseFloat(numericMatch[1]) : null
  };
}

export function getScenarioChiefComplaint(scenarioLike) {
  const output = toScenarioOutput(scenarioLike);
  return normalizeWhitespace(output.chiefComplaint || output.ChiefComplaint || "");
}

export function getScenarioPathology(scenarioLike) {
  const output = toScenarioOutput(scenarioLike);
  const pathology =
    output.primaryAssessment?.impression ||
    output.primaryAssessment?.Impression ||
    output.differentialDiagnosis?.[0]?.condition ||
    scenarioLike?.majorSystemInvolved ||
    "";
  return normalizeWhitespace(pathology);
}

export function getScenarioAgeInfo(scenarioLike) {
  const output = toScenarioOutput(scenarioLike);
  const ageRaw =
    output.patientInfo?.age ||
    output.PatientDemographics?.Age ||
    scenarioLike?.ageRange ||
    "";
  return parseAgeValue(ageRaw);
}

export function getScenarioSkillLevel(scenarioLike) {
  return normalizeWhitespace(scenarioLike?.levelOfCare || "");
}

export function buildGeneratedScenarioName(scenarioLike, fallbackTitle = "Clinical Scenario") {
  const output = toScenarioOutput(scenarioLike);
  const explicitName = normalizeWhitespace(output.scenarioName || output.ScenarioName || "");
  if (explicitName) return explicitName;

  const age = getScenarioAgeInfo(scenarioLike).text || "Unknown age";
  const sex = normalizeWhitespace(output.patientInfo?.sex || output.PatientDemographics?.Sex || "Unknown sex");
  const complaint = getScenarioChiefComplaint(scenarioLike) || normalizeWhitespace(fallbackTitle);

  return `${age} ${sex} - ${complaint}`;
}

function slugify(text) {
  return normalizeWhitespace(text)
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function buildScenarioDownloadFilename(scenarioLike, extension = "pdf", fallbackTitle = "clinical-scenario") {
  const name = buildGeneratedScenarioName(scenarioLike, fallbackTitle);
  const slug = slugify(name) || "clinical-scenario";
  const scenarioId = scenarioLike?.id || scenarioLike?.scenarioOutput?.id || "";
  const suffix = scenarioId ? `-${scenarioId}` : "";
  return `${slug}${suffix}.${extension}`;
}
